import STORAGE from '@spero/spero-utils/src/constants/STORAGE'
import queryString from '@spero/spero-utils/src/helpers/queryString'
import CONFIG from '@/config'
import parse from 'url-parse'

import merge from 'merge'
import session from '@spero/spero-utils/src/helpers/session'
import storage from '@spero/spero-utils/src/helpers/storage'

const defaultOptions = {
  use: ['request', 'response']
}

export default function (client, options) {
  const opts = merge(defaultOptions, options)

  const interceptors = {
    request: {
      success (config) {
        const appVersion = parse(location.href, true).query.appVersion || session.get(STORAGE.APP_VERSION) || '0.0.0'
        console.log('appVersion', appVersion)
        config.headers.token = session.get(STORAGE.LOGIN_TOKEN) || queryString.query(location.search).token || storage.get(STORAGE.LOGIN_TOKEN)
        config.headers.platform = CONFIG.platform
        return config
      },
      error (e) {
        return Promise.reject(e)
      }
    },
    response: {
      success (res) {
        return res
      },
      async error(e) {
        const res = e.response
        // status === 401，token 失效 重新拉取授权
        if (res && res.status === 401) {
          return Promise.reject(e)
        }
      }
    }
  }

  opts.use.forEach(use => {
    client.interceptors[use].use(interceptors[use].success, interceptors[use].error)
  })

  return client
}
